import { defineStore } from "pinia";
import storage from '../utils/Storage';
import type { ICirrusReaderHighlightData } from "../shared/CirrusReaderModel";

interface CirrusHighlightsState {
    highlights: ICirrusReaderHighlightData[]
}

export const useCirrusHighlightsStore = defineStore('cirrusHighlights', {
  state: (): CirrusHighlightsState => ({
    highlights: [],
  }),
  actions: {
    addHighlight(highlight: ICirrusReaderHighlightData){
        this.highlights.push(highlight);
    },
    getHighlight(locator: string){
      const index = this.highlights.findIndex((h) => h.locator === locator);
      if (index === -1) return;
      return this.highlights[index];
    },
    deleteHighlight(locator: string) {
        this.highlights = this.highlights.filter((highlight) => highlight.locator !== locator);
    },
    updateHighlight(locator: string, highlight: ICirrusReaderHighlightData) {
      const index = this.highlights.findIndex((h) => h.locator === locator);
      if (index === -1) return;

      this.highlights[index] = {
        ...this.highlights[index],
        ...highlight,
      };
    }
  },
  persist: {
    pick: [
      'highlights'
    ],
    storage
  }
});
